// @ts-ignore
import React from "react";

// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { token } from "@atlaskit/tokens";

import { LinkWithIcon, LinkWithIconProps } from "./link-with-icon";
import { ListOfLinksHeaderText } from "./list-of-links-header-text";

export type ListOfLinksProps = {
    readonly isSideBar: boolean;
    readonly headerText: string;
    readonly listOfLinkWithProps: LinkWithIconProps[];
};

function listOfLinksContainerStyle(isSideBar: boolean) {
    const paddingValue = isSideBar
        ? `0 0 ${token("space.250")} 0`
        : `0 ${token("space.250")} 0 0`;
    const ListOfLinksContainerStyle = css`
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        float: left;
        padding: ${paddingValue};
        margin-bottom: 10px;
    `;
    return ListOfLinksContainerStyle;
}

export const ListOfLinks = ({
    isSideBar,
    headerText,
    listOfLinkWithProps
}: ListOfLinksProps) => {
    const linkListContainerStyle = listOfLinksContainerStyle(isSideBar);
    return (
        <div css={linkListContainerStyle}>
            <ListOfLinksHeaderText
                isSideBar={isSideBar}
                headerText={headerText}
            />
            {listOfLinkWithProps.map((listOfLinkWithProp, index) => {
                const listOfLinkKey =
                    headerText.trim().toLowerCase() +
                    "-" +
                    listOfLinkWithProp.linkText.trim().toLowerCase() +
                    "-" +
                    index.toString();
                return (
                    <React.Fragment key={listOfLinkKey}>
                        <LinkWithIcon {...listOfLinkWithProp} />
                    </React.Fragment>
                );
            })}
        </div>
    );
};
